import { Component, Input } from '@angular/core';
import { TargetAudienceGenderEnum } from '../../../../features/surveys-requests/models/enums/TargetAudienceGenderEnum';

@Component({
  selector: 'app-surveys-requests-target-audience-gender',
  standalone: false,
  templateUrl: './surveys-requests-target-audience-gender.component.html'
})
export class SurveysRequestsTargetAudienceGenderComponent {
  @Input() target!: TargetAudienceGenderEnum;
  targetAudienceGender = TargetAudienceGenderEnum

}
